module.exports = __webpack_public_path__ + "static_portal/img/2.b3768655.jpg";